export const SEARCH_SCOPE_OPTIONS = [
  { label: '全部', value: 'all', path: '/search' },
  { label: '史料知识', value: 'knowledge', path: '/knowledge' },
  { label: '馆藏资源', value: 'resources', path: '/resources' },
  { label: '主题展览', value: 'exhibition', path: '/exhibition' }
]

export const SEARCH_CATEGORY_LINKS = SEARCH_SCOPE_OPTIONS.filter((item) => item.value !== 'all')

export function navigateBySearchScope(router, scope, keyword) {
  const trimmed = (keyword || '').trim()
  const target = SEARCH_SCOPE_OPTIONS.find((item) => item.value === scope) || SEARCH_SCOPE_OPTIONS[0]
  router.push({
    path: target.path,
    query: trimmed ? { keyword: trimmed } : {}
  })
}

export const LIST_PAGE_PATHS = ['/knowledge', '/resources', '/exhibition']

export function isListPagePath(path) {
  return LIST_PAGE_PATHS.includes(path)
}
